import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css']
})
export class DeleteModalComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data :any) { }

  get deleteText(): string {
    const lang = localStorage.getItem('lang') || 'en-US';
    const dict: Record<string, string> = {
      'en-US': 'Delete',
      'hi-IN': 'डिलीट',
      'mr-IN': 'डिलीट',
      'bn-IN': 'ডিলিট'
    };
    return dict[lang] || 'Delete';
  }

  get cancelText(): string {
    const lang = localStorage.getItem('lang') || 'en-US';
    const dict: Record<string, string> = {
      'en-US': 'Cancel',
      'hi-IN': 'कैंसल',
      'mr-IN': 'कॅन्सल',
      'bn-IN': 'ক্যান্সেল'
    };
    return dict[lang] || 'Cancel';
  }

  ngOnInit(): void {
    console.log("deleted id ", this.data);
  }
}
